<template>
    <div class="schedule">
        <slot name="main"></slot>
    </div>
</template>
<script>
    import dateFormat from 'dateformat'

    export default {

        props: [

        ],

        methods: {
        },

        watch: {

        },

        mounted: function() {
            var navItems = document.getElementsByClassName('schedule__nav-item');
            navItems[0].click();
        },
    }
</script>


// WEBPACK FOOTER //
// Schedule.vue?1873b794